module.exports = __webpack_public_path__ + "img/cna-logo-white.c484a644.svg";